import { __ } from "@wordpress/i18n";
import React from 'react';
import Hint from '../components/Hint/Hint';
import RepeatableField from '../components/RepeatableField/RepeatableField';
import Switch from '../components/Switch/Switch';
import TagInput from '../components/TagInput/TagInput';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
const Page = ({handleChange}) => {
    const pageList = ultimate_security_ajax_obj?.pageList || [];
    const productCategoryList = ultimate_security_ajax_obj?.productCategoryList || [];
    const userRoleList = (ultimate_security_ajax_obj?.userRoleList || []).filter(
        (role) => role.code !== 'administrator'
      );      
    const {
        settingData
    } = useMenu();
    return (
        <>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Disable Right Click On Whole Site", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Protect your content by disabling right-click functionality across your entire website. Prevent unauthorized copying and content theft.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/disable right click.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.disable_right_click.enable"
                                    checked={settingData?.security?.disable_right_click?.enable} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Disable Right Click For Pages.", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Protect your images and descriptions by disabling right-click functionality on WooCommerce pages. Safeguard your store's content effortlessly.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("No Hint", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='security.disable_right_click.page_ids' 
                                        type='page' 
                                        initialTags={settingData?.security?.disable_right_click?.page_ids} 
                                        handleChange={handleChange} 
                                        whitelist={pageList}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Disable Right Click For Product Pages", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Protect your product images and descriptions by disabling right-click functionality on product pages. Safeguard your store's content effortlessly.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/disable for product pages.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.disable_right_click.enable_woocommerce"
                                    checked={settingData?.security?.disable_right_click?.enable_woocommerce} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10  mt-3">
                                <div className="title-group d-flex">
                                    <Hint content={__("Enable/disable right click.", "ultimate-security")}/>
                                    <TagInput 
                                        name='security.disable_right_click.product_cats' 
                                        type='category' 
                                        initialTags={settingData?.security?.disable_right_click?.product_cats} 
                                        handleChange={handleChange} 
                                        whitelist={productCategoryList}
                                    />
                                </div>
                            </div>    
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Disable Right Click For Custom URLs", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Easily disable right-click functionality on specific custom URLs to protect targeted content from unauthorized actions.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex">
                                    <Hint content={__("Enable/disable for custom URLs.", "ultimate-security")}/>
                                    <RepeatableField 
                                        inputType = 'url'
                                        name='security.disable_right_click.custom_uris'
                                        options={{
                                            addButton: 'Add New URL',
                                        }}
                                        savedData={settingData?.security?.disable_right_click?.custom_uris} 
                                        handleChange={handleChange}
                                    />
                                </div>
                            </div>           
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Disable For User Roles", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Control right-click restrictions based on user roles. Allow trusted users access while restricting others.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex">
                                    <Hint position="top" content={__("Enable/disable user role.", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='security.disable_right_click.user_roles' 
                                        type='role' 
                                        initialTags={settingData?.security?.disable_right_click?.user_roles} 
                                        handleChange={handleChange} 
                                        whitelist={userRoleList}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(Page, 'security.disable_right_click');